const state = {
  tab: '0'
}

const mutations = {
  CHANGE_TAB: (state, data) => {
    state.tab = data.value
  }
}

const actions = {
  changeTab({ commit }, data) {
    commit('CHANGE_TAB', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
